import { render, staticRenderFns } from "./SuggestionDetail.vue?vue&type=template&id=009f2076&scoped=true&"
import script from "./SuggestionDetail.vue?vue&type=script&lang=ts&"
export * from "./SuggestionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionDetail.vue?vue&type=style&index=0&id=009f2076&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f2076",
  null
  
)

export default component.exports